import React from "react";
import { useLocation } from "react-router-dom";
import HorizontalTabs from "../../common-ui-components/components/horizontal-tabs/HorizontalTabs";

import InventoryOverview from "app/inventory-new/overview/Overview";
import PatchOverview from "app/patch/overview/tabs/patch/Patch";
import ThreatsOverview from "app/patch/overview/tabs/threats/Threats";
import GettingStarted from "./getting started/GettingStarted";
import Resources from "./resources/Resource";
import UpdatesTabs from "common-ui-components/components/UpdatesTabs/UpdatesTabs";
import { useModuleAlerts } from "message-framework/hooks/useModuleAlerts";
import { PRODUCT_CONTEXT } from "common-ui-components/components/utils/Config";
import styles from "./Home.module.css";

// Every route segment that can follow the base path. Stripping all of them
// keeps basePath (e.g. "/em/app/home") stable on every tab, including the
// right tabs.
const TAB_SEGMENTS_REGEX =
  /\/(inventory|patches|threats|getting-started|resources)(\/.*)?$/;

const Home = () => {
  const { pathname } = useLocation();

  // Derive the real base URL from the actual pathname, so a route pattern
  // like "/*" can never leak into the tab URLs.
  const basePath = pathname.replace(TAB_SEGMENTS_REGEX, "").replace(/\/$/, "");

  const rightTabs = [
    {
      key: "getting-started",
      header: "Getting Started",
      url: `${basePath}/getting-started`,
      children: <GettingStarted />,
    },
    {
      key: "resources",
      header: "Resources",
      url: `${basePath}/resources`,
      children: <Resources />,
    },
  ];

  const leftTabs = [
    {
      key: "inventory",
      header: "Inventory",
      url: `${basePath}/inventory`,
      children: <InventoryOverview embedded />,
    },
    {
      key: "threats",
      header: "Threats",
      url: `${basePath}/threats`,
      children: <ThreatsOverview />,
    },
    {
      key: "patches",
      header: "Patches",
      url: `${basePath}/patches`,
      children: <PatchOverview />,
    },
  ];

  const tabs = leftTabs.filter(({ key }) => {
    if (PRODUCT_CONTEXT === "am") return key === "inventory";
    if (PRODUCT_CONTEXT === "pm") return key === "patches";
    if (PRODUCT_CONTEXT === "vm") return key !== "inventory";
    return true;
  });

  const activeTabIndex = tabs.findIndex(
    (tab) => pathname === tab.url || pathname.startsWith(`${tab.url}/`),
  );

  const { messages } = useModuleAlerts([
    {
      type: "route",
      path: basePath,
      key: "HOME",
    },
  ]);

  return (
    <div style={{ padding: "0.8rem" }}>
      <div className={[styles.container, "scrollBarOnHover"].join(" ")}>
        <UpdatesTabs messages={messages} />
        <HorizontalTabs
          tabs={tabs}
          rightTabs={rightTabs}
          initialTabIndex={activeTabIndex === -1 ? 0 : activeTabIndex}
          actAsNavBar
          containerProps={{
            style: {
              fontSize: "16px",
              padding: "1rem",
              paddingBottom: 0,
            },
          }}
        />
      </div>
    </div>
  );
};

export default Home;